import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'without-suitability-disclaimer',
    templateUrl: './without-suitability-disclaimer.component.html',
    styleUrls: ['without-suitability-disclaimer.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class WithoutSuitabilityDisclaimerComponent {}
